import { Trans } from '@lingui/macro'
import { EgretLoadable } from 'egret'
import { authRoles } from '../../auth/authRoles'
import { internalEnvs } from '../../services/sfAuth/sfAuthConfig'
import GenerateFillablePDFForm from './screens/GenerateFillablePDFForm'

const ProgramManagerApplicationList = EgretLoadable({
  loader: () => import('./ProjectManagerApplicationList')
})

const BudgetEmbedded = EgretLoadable({
  loader: () => import('./BudgetEmbedded')
})

const ExportSurveys = EgretLoadable({
  loader: () => import('./ExportSurveys')
})

const ExportImportObjects = EgretLoadable({
  loader: () => import('./ExportImportObjects')
})

const TranslationsEditor = EgretLoadable({
  loader: () => import('./TranslationsEditor')
})

const FormConfigurablePrintView = EgretLoadable({
  loader: () => import('./FormConfigurablePrintView')
})

const ConfigurePortalConfigurations = EgretLoadable({
  loader: () => import('./ConfigurePortalConfigurations')
})

const ConfigureFundingStreams = EgretLoadable({
  loader: () => import('./funding-streams/ConfigureFundingStreams')
})

const TechnicalAdvisoryRanking = EgretLoadable({
  loader: () => import('./TechnicalAdvisoryRanking')
})

const Contract = EgretLoadable({
  loader: () => import('./Contract')
})

const ConfigureUserPermissions = EgretLoadable({
  loader: () => import('./ConfigureUserPermissions')
})

const AdminMultiuserPanel = EgretLoadable({
  loader: () => import('../forms/multiuser/admin/AdminMultiuserPanel')
})

const PageTranslations = EgretLoadable({
  loader: () => import('./PageTranslations')
})

const internalRoutes = [
  {
    path: '/internal/project-schedule/:id',
    component: EgretLoadable({
      loader: () => import('./GranteeReportEditor')
    }),
    auth: authRoles.pm,
    isTranslatable: true,
    label: <Trans>INTERNAL_ROUTES_PM_SCHEDULE_EDITOR_LABEL</Trans>,
    showCollapseBtn: true,
    collapseByDefault: true
  },
  {
    path: '/internal/TranslationsEditor',
    component: TranslationsEditor,
    auth: authRoles.translator,
    isTranslatable: true,
    label: <Trans>INTERNAL_ROUTES_TRANSLATIONS_EDITOR_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/internal/ProgramManagerApplicationList',
    component: ProgramManagerApplicationList,
    auth: authRoles.pm,
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_APPLICATION_LIST</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/internal/contract/:id',
    component: Contract,
    env: internalEnvs,
    auth: authRoles.pm,
    isTranslatable: true,
    label: <Trans>INTERNAL_ROUTES_CONTRACT_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/internal/TechnicalAdvisoryRanking',
    component: TechnicalAdvisoryRanking,
    auth: authRoles.pm,
    isTranslatable: true,
    label: <Trans>INTERNAL_ROUTES_TECHNICAL_ADVISORY_RANKING_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/internal/widgets/budget/:id',
    component: BudgetEmbedded,
    auth: authRoles.pm,
    isTranslatable: true,
    label: <Trans>INTERNAL_ROUTES_BUDGET_VIEW_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/internal/ExportSurveys',
    component: ExportSurveys,
    auth: authRoles.pm,
    isTranslatable: true,
    label: <Trans>INTERNAL_ROUTES_EXPORT_SURVEYS_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/internal/create-form-preview-url',
    component: FormConfigurablePrintView,
    auth: authRoles.editor,
    isTranslatable: true,
    label: <Trans>NAVIGATIONS_CONFIGURABLE_FORM_URLS</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/internal/ConfigureFundingStreams',
    component: ConfigureFundingStreams,
    auth: authRoles.admin,
    isTranslatable: true,
    label: <Trans>INTERNAL_ROUTES_CONFIGURE_FUNDING_STREAMS_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/internal/PortalConfigurations',
    component: ConfigurePortalConfigurations,
    auth: authRoles.admin,
    isTranslatable: true,
    label: <Trans>INTERNAL_ROUTES_PORTAL_CONFIGURATIONS_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/internal/ConfigureUserPermissions',
    component: ConfigureUserPermissions,
    auth: authRoles.admin,
    isTranslatable: true,
    label: <Trans>INTERNAL_ROUTES_CONFIGURE_USER_PERMISSIONS_LABEL</Trans>,
    showCollapseBtn: true
  },
  {
    path: '/internal/page-translations',
    component: PageTranslations,
    auth: authRoles.admin,
    showCollapseBtn: true
  },
  {
    path: '/internal/ExportImportObjects',
    component: ExportImportObjects,
    auth: authRoles.admin,
    showCollapseBtn: true
  },
  {
    path: '/internal/active-sessions',
    component: AdminMultiuserPanel,
    auth: authRoles.admin,
    showCollapseBtn: true
  },
  {
    path: '/internal/generate-pdf-for-application',
    component: GenerateFillablePDFForm,
    auth: authRoles.admin,
    showCollapseBtn: true
  }
]

export default internalRoutes
